<template>
  <div>
    <headTop head-title='登录' :go-back="true"></headTop>
    <div class="login-wrap" ref="login">
      <div class="content">
        <ul class="login_ul">
          <li class="login_li">
            <!-- <i class="icon my"></i> -->
            <span class="left_p name"></span><input type="text" placeholder="请输入用户名" v-model="userName" maxlength="16" minlength="4" autocomplete="off">
          </li>
          <li class="login_li">
            <!-- <i class="icon icon_mima"></i> -->
            <span class="left_p pwd"></span><input type="password" placeholder="请输入密码"  v-model="passWord" maxlength="16" minlength="6" autocomplete="off">
          </li>
          <li class="login_li">
            <!-- <i class="icon icon_c"></i> -->
            <span class="left_p"></span><input class="captcha_wrapper" @focus="showCaptchaEvent" name="captcha" v-model="captcha" type="text" placeholder="请输入验证码" maxlength="16" autocomplete="off"><img ref="login_captcha_img" @click="changeImg($event)" v-show="showCaptcha" @load="loadImage"/>
          </li>
        </ul>
        <div class="minWord">
          <span class="color" @click="newOpen()">联系客服</span>
        </div>
        <div class="login-btn">
          <span class="btn" :class="{on:btnShow}" @click="login()">登&nbsp;&nbsp;&nbsp;录</span>
        </div>
        <div class="register">
          <div class="div-1" @click="showRePage">立即注册</div>
        </div>
        <div class="tip">
          温馨提示：交易会员账号前，请先注册“账号交易系统”账号
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from '@/components/common/header/head'
import { userResource } from '@/resource/resource'
import { mapState, mapMutations } from 'vuex'
import { addCookie } from '@/common/js/cookies'
import { saveToLocal } from '@/common/js/store'
import BScroll from 'better-scroll'
const ERR_OK = 0

  export default {
    name: 'login',
    data () {
      return {
        captcha: '', // 验证码
        showCaptcha: false,
        userName: '',
        passWord: '',
        btnShow: true,
        isSubmit: false,
        popupObj: null
      }
    },
    computed: {
      ...mapState([
        'service', 'config_info'
      ])
    },
    created () {
    },
    mounted () {
      this.$nextTick(() => {
        this._initScroll()
      })
    },
    methods: {
      // 显示验证码图片
      showCaptchaEvent () {
        if (!this.showCaptcha) {
          this.$nextTick(() => {
            userResource.captcha().then(res => {
              // console.log(window.URL.createObjectURL(res.body))
              this.$refs.login_captcha_img.src = window.URL.createObjectURL(res.body)
            })
            // this.$refs.login_captcha_img.src = captchaResource.getCode() + Date.parse(new Date()) / 1000
          })
        }
        this.showCaptcha = true
      },
      // 更换验证码图片
      changeImg (e) {
        userResource.captcha().then(res => {
          e.target.src = window.URL.createObjectURL(res.body)
        })
        // e.target.src = captchaResource + Date.parse(new Date()) / 1000
      },
      // 验证码加载完成后销毁对象释放内存
      loadImage() {
        window.URL.revokeObjectURL(this.$refs.login_captcha_img.src)
      },
      login () {
        if (!this.isSubmit) {
          this.isSubmit = true
          userResource.login({ username: this.userName, password: this.passWord, captcha: this.captcha }).then(response => {
            // console.log(response)
            response = response.body
            if (response.errcode === ERR_OK) {
              // this.getPopup()
              saveToLocal('token', response.data['access-token'])
              addCookie('isLogined', true, 120)
              // this.RECORD_USERINFO(response.data)
              this.getUserInfo()
              if (this.$route.query.redirect) {
                //  let redirect = decodeURIComponent(this.$route.query.redirect)
                let redirect = this.$route.query.redirect
                this.$router.replace(redirect)
              } else {
                this.$router.push('/')
              }
            } else {
              this.isSubmit = false
              this.captcha = ''
              this.$nextTick(() => {
                userResource.captcha().then(res => {
                  this.$refs.login_captcha_img.src = window.URL.createObjectURL(res.body)
                })
                // this.$refs.login_captcha_img.src = captchaResource + Date.parse(new Date()) / 1000
              })
            }
          }, () => {
            this.isSubmit = false
            this.captcha = ''
            this.$nextTick(() => {
              userResource.captcha().then(res => {
                this.$refs.login_captcha_img.src = window.URL.createObjectURL(res.body)
              })
              // this.$refs.login_captcha_img.src = captchaResource + Date.parse(new Date()) / 1000
            })
          })
        }
      },
      // 会员等级的信息,信息未读数和任务未读数信息
      getUserInfo() {
        userResource.info().then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.RECORD_USERINFO(res.data)
          }
        })
      },
      showRePage () {
        if (this.$route.query.redirect) {
          //  let redirect = decodeURIComponent(this.$route.query.redirect)
          let redirect = this.$route.query.redirect
          this.$router.push({path: 'register', query: {redirect: redirect}})
        } else {
          this.$router.push('/register')
        }
      },
      _initScroll() {
        if (!this.loginScroll) {
          this.loginScroll = new BScroll(this.$refs.login, {
            click: true
          })
        } else {
          this.loginScroll.refresh()
        }
      },
      newOpen () {
        if (this.config_info.service_repwd_url) {
          window.open(this.config_info.service_repwd_url)
        }
      },
      // 更新vuex状态信息
      ...mapMutations([
        'RECORD_USERINFO',
        // 'BALANCE',
        'LEVELINFO',
        'SERVICE'
      ])
    },
    watch: {
      // 'showLoginPage': function(val, oldVal) {
      //   if (val) {
      //     this.$nextTick(() => {
      //       if (!this.loginScroll) {
      //         this.loginScroll = new BScroll(this.$refs.login, {
      //           click: true
      //         })
      //       } else {
      //         this.loginScroll.refresh()
      //       }
      //     })
      //     this.userName = ''
      //     this.passWord = ''
      //     this.isSubmit = false
      //   }
      // }
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  .login-wrap
    position fixed
    top 0.9rem
    left 0
    bottom 0
    width 100%
    z-index 30
    background-color #f4f4f4
    .content
      padding-top 0.32rem
      font-size $fz-t3
      width 100%
      .login_ul
        .login_li
          display flex
          background #ffffff
          border-bottom 1px solid #f4f4f4
          box-sizing border-box
          align-items center
          &:last-child
            position relative
            border-bottom none
          // .icon
          //   display inline-block
          //   background-size cover
          //   &.my
          //     margin 0.34rem  0.2rem
          //     width 0.21rem
          //     height 0.24rem
          //     bg-image('my')
          //   &.icon_mima
          //     margin 0.34rem  0.2rem
          //     width 0.21rem
          //     height 0.24rem
          //     bg-image('icon_mima')
          //   &.icon_c
          //     margin 0.37rem  0.17rem
          //     width 0.24rem
          //     height 0.21rem
          //     bg-image('icon_c')
          & > input
            flex 1
            height 0.96rem
            padding-left 0.3rem
            outline none
            // color $c-b5
          & > img
            position absolute
            right 0
            top 0
            width 2.4rem
            height 0.96rem
            background-size cover
            background-repeat no-repeat
          .left_p
            display inline-block
            // margin-left 0.3rem
            line-height 0.96rem
            margin 0 0 0 0.3rem
            text-align right
            color $c-b1
            width 0.24rem
            &.name
              width 0.24rem
              height 0.28rem
              background-size 0.24rem 0.28rem
              bg-image('name')
            &.pwd
              width 0.24rem
              height 0.27rem
              background-size 0.24rem 0.27rem
              bg-image('pwd')
            .red
              color #cd3c29
          // .captcha_wrapper
          //   & + img
          //     position absolute
          //     border-radius 20px
          //     right 0
          //     cursor pointer
      .minWord
        // visibility hidden
        margin 0.30rem 0 0.48rem
        font-size $fz-t3
        // height 0.2rem
        padding-right 0.42rem
        padding-left 0.42rem
        color #38ADFF
        text-align right
        // display flex
        // justify-content space-between
        // .color
        //   color #666666
      .login-btn
        margin 0 0.32rem 0.32rem 0.32rem
        font-size $fz-t5
        text-align center
        .btn
          display inline-block
          height 0.8rem
          width 6.88rem
          background-color $blue
          border-radius 0.1rem
          text-align center
          line-height 0.8rem
          color #ffffff
          &.on
            background-color $blue
      .register
        margin 0 0.32rem
        text-align center
        font-size $fz-t5
        .div-1
          height 0.8rem
          background-color $blue
          border-radius 0.1rem
          width 6.88rem
          color #ffffff
          line-height 0.8rem
          text-align center
          margin-bottom 0.4rem
      .tip
        font-size $fz-t1
        color $c-b3
        text-align center
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue